import type { GraphValidationResultDto } from "@store/services/documentService"
import { Button, Paper, TableCell, TableHead, TableRow } from "@mui/material"
import Table from "@mui/material/Table"
import TableBody from "@mui/material/TableBody"
import TableContainer from "@mui/material/TableContainer"

type SamplingValidationResultsProps = {
  result: GraphValidationResultDto
}

export const SamplingValidationResults = ({ result }: SamplingValidationResultsProps) => {
  const errors = result.message ?? []
  const warnings = result.warnings ?? []

  const handleDownload = () => {
    const rows = [
      ...errors.map((error) => `Errors,${error}`),
      ...warnings.map((warning) => `Warnings,${warning}`),
    ]
    const csv = `data:text/csv;charset=utf-8,Type,Message\n${rows.join("\n")}`

    window.open(encodeURI(csv))
  }

  return (
    <>
      <Button variant="contained" onClick={handleDownload} sx={{ mb: 1 }}>
        Download CSV
      </Button>
      {errors.length > 0 && <ValidationResultsTable data={errors} type="Errors" />}
      {warnings.length > 0 && <ValidationResultsTable data={warnings} type="Warnings" />}
    </>
  )
}

const ValidationResultsTable = ({
  data,
  type,
}: {
  data: string[]
  type: "Errors" | "Warnings"
}) => (
  <TableContainer component={Paper} sx={{ mt: 1 }}>
    <Table size="small" stickyHeader>
      <TableHead>
        <TableRow>
          <TableCell align="left" sx={{ color: type === "Errors" ? "error.main" : "warning.main" }}>
            <strong>{type}</strong>
          </TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {data.map((message, index) => (
          <TableRow key={`${type}-${index}`}>
            <TableCell>{message}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
)
